/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetComponentResponseDto } from './AssetComponentResponseDto';
import {
    AssetComponentResponseDtoFromJSON,
    AssetComponentResponseDtoFromJSONTyped,
    AssetComponentResponseDtoToJSON,
    AssetComponentResponseDtoToJSONTyped,
} from './AssetComponentResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListAssetComponentsResponseDto
 */
export interface ListAssetComponentsResponseDto {
    /**
     * 
     * @type {Array<AssetComponentResponseDto>}
     * @memberof ListAssetComponentsResponseDto
     */
    data: Array<AssetComponentResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListAssetComponentsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListAssetComponentsResponseDto interface.
 */
export function instanceOfListAssetComponentsResponseDto(value: object): value is ListAssetComponentsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListAssetComponentsResponseDtoFromJSON(json: any): ListAssetComponentsResponseDto {
    return ListAssetComponentsResponseDtoFromJSONTyped(json, false);
}

export function ListAssetComponentsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssetComponentsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssetComponentResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListAssetComponentsResponseDtoToJSON(json: any): ListAssetComponentsResponseDto {
    return ListAssetComponentsResponseDtoToJSONTyped(json, false);
}

export function ListAssetComponentsResponseDtoToJSONTyped(value?: ListAssetComponentsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssetComponentResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

